import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchVirtualAccountHistoryForCurrentUser} from '../../../actions/usageStatus.actions';
import {formatUtcDateToLocalDateFormat} from '../../../util/timeUtils';
import moment from 'moment';
import {PageSubTitle, Table} from '../../Common/PageComponents';
import commaNumber from 'comma-number';

const stateToProps = state => {
  return {
    virtualAccountHistories: state.usageStatus.virtualAccountHistories,
    pcbId: state.user.pcbId,
  };
};

const VIRTUAL_ACCOUNT_STATUSES = {
  DEPOSIT_STANDBY: '입금대기',
  DEPOSIT_COMPLETED: '입금완료',
};

class VirtualAccount extends Component {
  componentDidMount() {
    this.props.dispatch(fetchVirtualAccountHistoryForCurrentUser());
  }

  _renderVirtualAccountList(virtualAccountHistories) {
    if (virtualAccountHistories && virtualAccountHistories.length > 0) {
      return virtualAccountHistories.map((virtualAccountHistory, index) => (
        <tr key={index}>
          <td>{virtualAccountHistory.bankName}</td>
          <td>{virtualAccountHistory.bankAccountNo}</td>
          <td>{commaNumber(virtualAccountHistory.price)}원</td>
          <td>
            {virtualAccountHistory.virtualAccountState === 'DEPOSIT_STANDBY' &&
            moment(virtualAccountHistory.expirationDate)
              .utc()
              .isBefore(moment().utc())
              ? '만료'
              : VIRTUAL_ACCOUNT_STATUSES[virtualAccountHistory.virtualAccountState]}
          </td>
          <td>{formatUtcDateToLocalDateFormat(virtualAccountHistory.expirationDate)}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="5">최근 한달 간 발급된 가상계좌가 없습니다.</td>
      </tr>
    );
  }

  render() {
    return (
      <div>
        <PageSubTitle title="가상계좌 발급현황" />
        <Table>
          <colgroup>
            <col style={{width: '65px'}} />
            <col style={{width: '90px'}} />
            <col style={{width: '92px'}} />
            <col style={{width: '92px'}} />
            <col style={{width: '92px'}} />
          </colgroup>
          <thead>
            <tr>
              <th>은행명</th>
              <th>계좌번호</th>
              <th>금액</th>
              <th>상태</th>
              <th>만기일</th>
            </tr>
          </thead>
          <tbody>{this._renderVirtualAccountList(this.props.virtualAccountHistories)}</tbody>
        </Table>
      </div>
    );
  }
}

export default connect(stateToProps)(VirtualAccount);
